import { HttpClient, HttpClientModule } from "@angular/common/http";
import { UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogConfig } from "@angular/material/dialog";
import { jsonParse } from "src/app/app.component";
import { environment } from "src/environments/environment";
import { DocumentViewPopupComponent } from "../components/document-view-popup/document-view-popup.component";

export function getAllFieldDetails(section, field_arr) {

  try {
    if (section && section.length && typeof section == 'object') {
      for (let i = 0; i < section.length; i++) {
        if (field_arr && typeof field_arr == 'object' && field_arr.length) {
          try {
            let fields = getAllFieldDetails(section[i], field_arr)
            // field_arr.push(...fields)
          }
          catch (err) {
            field_arr = getAllFieldDetails(section[i], field_arr)
          }
        }
        else {
          field_arr = [];
          try {
            let fields = getAllFieldDetails(section[i], field_arr)
            // field_arr.push(...fields)
          }
          catch (err) {
            field_arr = getAllFieldDetails(section[i], field_arr)
          }
        }
      }
    }
    if (section && section.field_details && section.field_details.length) {
      for (let i = 0; i < section.field_details.length; i++) {
        let field = section.field_details[i];
        field_arr.push(field)
      }
    }

    if (section && section.sections && section.sections.length) {
      for (let i = 0; i < section.sections.length; i++) {
        field_arr = getAllFieldDetails(section.sections[i], field_arr)
      }
    }
  }
  catch (err) {

  }

  return field_arr || []
}

export function evalObject(request, parent_form, parent_functions?, other_obj?) {
  if (request && typeof request == 'object') {
    let keys = Object.keys(request);
    if (keys && keys.length) {
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        try {
          request[key] = eval(request[key]) || '';

        }
        catch (err) {
          request[key] = request[key];
        }
      }
    }
  }
  if (request && typeof request == 'object' && request.length) {
    for (let i = 0; i < request.length; i++) {
      request[i] = this.evalObject(request[i])
    }
  }
  return request
}

export function dynamicRequest(field, parent_form, parent_functions, masters, dynamic_svc, notification_svc) {
  let a = {
    "request": {
      "url": "GetReqBudget",
      "body": "",
      "params": { "org_id": "parent_form['value']['10118']['10055']['organization_node_code']", "ref_date": "parent_form['value']['10118']['10055']['req_end_date']" },
      "method": "get",
      "api_condition": "parent_form['value']['10118']['10055']['organization_node_code'] && parent_form['value']['10118']['10055']['req_end_date'] ",
      "after_response_expression": "parent_form.get('10118').get('30810').patchValue(res['data']['field_values'])"
    }
  }
  try {
    if (field && field.description && field.description.request) {
      let request = jsonParse(field.description.request);
      try {
        request = JSON.parse(JSON.stringify(request));
      }
      catch (err) {

      }
      let body;
      let params;
      let method;
      let url;
      if (request.body) {
        try {
          body = evalObject(request.body, parent_form, parent_functions)
        }
        catch (err) {
          body = request.body
        }
      }

      if (request.params) {
        try {
          params = evalObject(request.params, parent_form, parent_functions)
        }
        catch (err) {
          params = request.params
        }
      }
      if (request.method) {
        try {
          method = request.method
        }
        catch (err) {
          // method = request.method
        }
      }
      if (request.url && !request.disable_append_base_url) {
        url = environment.SERVER_URL + request.url
      }
      let evalCondition = (str) => {
        try {
          if (eval(str)) {
            return true
          }
          else {
            return false
          }
        }
        catch (err) {
          return true
        }
      }
      if (request && (!(request.api_condition) || evalCondition(request.api_condition))) {
        dynamic_svc.apiCall(request.method, url || request.url || '', body, params).subscribe(res => {
          if (res['status']) {
            if (request.after_response_expression) {
              try {
                eval(request.after_response_expression)
              }
              catch (err) {

              }
            }
            else {
              if (request.type == 1) {
                if (res && res['data'] && res['data']['Master']) {
                  masters[request.master_property_name] = (jsonParse(res['data'].Master)[request.master_property_name]) || [];
                }
              }
            }
          }
          else {
            notification_svc.snackbar(res['message'], 'Close', 5000)
          }
          // if (res && res['data'] && res['data']['Master']) {
          //   this.masters[master_condition.master_property_name] = (jsonParse(res['data'].Master)[master_condition.response_property_name]) || [];
          // }
        })
      }
    }
  }
  catch (err) {

  }
}

export function setPortalMasters(portal, portal_svc, values) {
  portal_svc.getPortalMasters(portal ? portal : '').subscribe(res => {
    if (res && values) {
      let value_arr = values.split(',')

      if (Object.keys(res) && Object.keys(res).length) {
        for (let i = 0; i < Object.keys(res).length; i++) {
          let arr = []
          for (let j = 0; j < value_arr.length; j++) {
            if (Object.keys(res)[i] == value_arr[j]) {
              arr.push(res[Object.keys(res)[i]])
            }
            else {
              arr.push(value_arr[j])
            }
            values = arr.toString()
          }
        }
      }
    }
  })
}

export function viewDocument(all_files, file, dialog, other_data?, serverFileName?, serverPathname?) {

  const dialogConfig = new MatDialogConfig()
  dialogConfig.width = '60%';
  dialogConfig.height = '80%';
  dialogConfig.panelClass = 'TM-Dialog';
  dialogConfig.data = {
    serverFilename: serverFileName,
    serverPathname: serverPathname
  };
  const dialogRef = dialog.open(DocumentViewPopupComponent, dialogConfig);
  (dialogRef.componentInstance).file = file;
  (dialogRef.componentInstance).all_files = cloneArray(all_files);
  (dialogRef.componentInstance).other_data = other_data;
  (dialogRef.componentInstance).serverFilename = serverFileName || 'fileName';
  (dialogRef.componentInstance).serverPathname = serverPathname || 'cdnPath';
  (dialogRef.componentInstance).index = all_files.indexOf(file) == -1 ? 0 : all_files.indexOf(file);
  dialogRef.afterClosed().subscribe(value => {
    if (value) {
    }
  }, err => {

  })

}
export function checkMobileScreen() {
  if (screen.width < 500) {
    return true;
  }
  return false;
}
export function getInvalidFields(form_group: UntypedFormGroup, translate, notification_srv, json_root_property, do_not_translate?) {
  if (form_group && form_group.controls) {
    let all_controls = Object.keys(form_group.controls);
    for (let i = 0; i < all_controls.length - 1; i++) {
      if (form_group.controls[all_controls[i]].errors) {
        let err
        if (form_group.controls[all_controls[i]].errors) {
          if (form_group.controls[all_controls[i]].errors.required) {
            err = 'ERROR.is_required'
          }
          else if (form_group.controls[all_controls[i]].errors.maxLength) {
            err = 'ERROR.max_length';
          }
          else if (form_group.controls[all_controls[i]].errors.minLength) {
            err = 'ERROR.minimum_length';
          }
          else if (form_group.controls[all_controls[i]].errors.min) {
            err = 'ERROR.min_value'
          }
          else if (form_group.controls[all_controls[i]].errors.max) {
            err = 'ERROR.max_value'
          }
          else {
            err = 'ERROR.invalid_input'
          }
          if (!do_not_translate) {
            translate.get([json_root_property + all_controls[i], err]).subscribe(res => {
              let message;
              let cname = res[json_root_property + all_controls[i]];
              let ename = res[err]
              message = cname + ' ' + ename
              notification_srv.error(message, "Close", 5000);
            })
          }
          else {
            translate.get([err]).subscribe(res => {
              let message;
              let cname = all_controls[i];
              let ename = res[err]
              message = cname + ' ' + ename
              notification_srv.error(message, "Close", 5000);
            })
          }



        }
        break;
      }
    }
    all_controls.forEach(key => {

    })
  }
}
export function getLocalStorageItem(name) {
  let item = localStorage.getItem(name);

  try {
    item = JSON.parse(item);
    return item
  }
  catch (err) {
    return item
  }
}
export function removeLocalStorageItem(name) {
  try {
    localStorage.removeItem(name);
  }
  catch (err) {
  }
}
export function getSessionStorageItem(name) {
  let item = sessionStorage.getItem(name);

  try {
    item = JSON.parse(item);
    return item
  }
  catch (err) {
    return item
  }
}
export function removeSessionStorageItem(name) {
  try {
    sessionStorage.removeItem(name);
  }
  catch (err) {
  }
}
export const cloneArray = (items) => {
  if (items && items.length) {
    return items.map(item => Object.assign({}, item));
  }
  else {
    return [];
  }
}


export function setValidatorsV3(form_group: UntypedFormGroup, field) {
  try {
    let validators = [];
    if (field.fieldID == 'percentageShare') {
      console.log('234')
    }

    if (field && field.UIValidationObjStruct) {
      if (!(field.UIValidationObjStruct && field.UIValidationObjStruct.min_length && field.UIValidationObjStruct.min_length.value)) {
        field.UIValidationObjStruct.min_length = {};
        field.UIValidationObjStruct.min_length.value = 0;
      }
      if (!((field.UIValidationObjStruct && field.UIValidationObjStruct.max_length && field.UIValidationObjStruct.max_length.value))) {
        field.UIValidationObjStruct.max_length = {};
        field.UIValidationObjStruct.max_length.value = 99999999;
      }
      if (field.UIValidationObjStruct && field.UIValidationObjStruct.mandatory && field.UIValidationObjStruct.mandatory.value) {
        validators.push(Validators.required);
      }
      if (field.UIValidationObjStruct && field.UIValidationObjStruct.pattern && field.UIValidationObjStruct.pattern.value) {
        validators.push(Validators.pattern(field.UIValidationObjStruct.pattern.value));
      }
      if (field.UIValidationObjStruct && field.UIValidationObjStruct.pattern && field.UIValidationObjStruct.pattern.value) {
        validators.push(Validators.pattern(field.UIValidationObjStruct.pattern.value));
      }
      if (field.UIValidationObjStruct.min_length.value != '' && field.UIValidationObjStruct.min_length.value != null) {
        field.UIValidationObjStruct.min_length.value = eval(field.UIValidationObjStruct.min_length.condition);
        validators.push(Validators.minLength(eval(field.UIValidationObjStruct.min_length.value)));
      }

      if (field.UIValidationObjStruct.max_length.value != '' && field.UIValidationObjStruct.max_length.value != null) {
        if (field.UIValidationObjStruct.max_length.condition) {
          field.UIValidationObjStruct.max_length.value = eval(field.UIValidationObjStruct.max_length.condition)
        }
        validators.push(Validators.maxLength(eval(field.UIValidationObjStruct.max_length.value)));
      }

      if (field.UIValidationObjStruct.min_value && field.UIValidationObjStruct.min_value.value != '' && field.UIValidationObjStruct.min_value.value != null) {
        if (field.UIValidationObjStruct.min_value.condition) {
          field.UIValidationObjStruct.min_value.value = eval(field.UIValidationObjStruct.min_value.condition)
        }
        validators.push(Validators.min(eval(field.UIValidationObjStruct.min_value.value)));
      }
      if (field.UIValidationObjStruct.max_value && field.UIValidationObjStruct.max_value.value != '' && field.UIValidationObjStruct.max_value.value != null) {
        if (field.UIValidationObjStruct.max_value.condition) {
          field.UIValidationObjStruct.max_value.value = eval(field.UIValidationObjStruct.max_value.condition)
        }
        validators.push(Validators.max(eval(field.UIValidationObjStruct.max_value.value)));
      }

      if (field.UIValidationObjStruct.disabled && field.UIValidationObjStruct.disabled.value != '' && field.UIValidationObjStruct.disabled.value != null) {
        validators = [];
      }
    }
    // if (validators && validators.length) {
    if (field.numberControl) {
      if (field.UIValidationObjStruct && field.UIValidationObjStruct.disabled) {
        if (field.UIValidationObjStruct.disabled.value == 1) {
          form_group.get(field.numberControl).disable();
        }
        else {
          form_group.get(field.numberControl).enable();
        }
      }
      // else{
      //   form_group.get(field.numberControl).enable();
      // }
      form_group.get(field.numberControl).setValidators(validators);
      form_group.get(field.numberControl).updateValueAndValidity();
    }

    if (field.UIValidationObjStruct && field.UIValidationObjStruct.disabled) {
      if (field.UIValidationObjStruct.disabled.value == 1) {
        form_group.get(field.fieldID).disable();
      }
      else {
        form_group.get(field.fieldID).enable();
      }
    }
    form_group.get(field.fieldID).setValidators(validators);
    form_group.get(field.fieldID).updateValueAndValidity();
    // }


  }
  catch (err) { }
}

export function getInvalidFieldsV3(form_group, translate, notification, section) {

  const controls = form_group.controls;
  let message;
  let invalid_name;
  for (const name in controls) {
    if (controls[name].invalid) {
      if (section.field_label[name]) {
        if (controls[name].errors && controls[name].errors.required) {
          message = section.field_label[name] + " is mandatory";
        }
        else {
          message = "Invalid input for " + section.field_label[name];
        }
        notification.error(message, "Close", 5000);
        try {
          if (section.ref) {
            section.ref.open();
          }
          let id = section.fieldID + name
          scrollTo(document.getElementById(id));
        } catch (error) {

        }
        break;


      }
      else {
        invalid_name = name;
      }
      break;
    }

  }

  if (invalid_name) {
    if (section.sections) {
      let found = 0;
      for (let i = 0; i < section.sections.length; i++) {
        if (invalid_name == section.sections[i].fieldID) {
          try {
            // section.openAccrodion = 1;
            // document.getElementById(section.sections[i].fieldID).click();
          } catch (error) {

          }
          // setTimeout(() => {
          found = 1;
          getInvalidFieldsV3(form_group.get(invalid_name), translate, notification, section.sections[i]);
          // });
          break;
        }
      }
      if (!found) {
        if (controls[invalid_name] && controls[invalid_name].controls) {
          getInvalidFieldsV3(controls[invalid_name], translate, notification, section)
        }
      }
    }
  }

  // if (invalid_Controls && this.invalid_Controls.length) {
  //   let message =if (form_group.controls[all_controls[i]].errors.required) {
  //   message = res + ' Field is mandatory'
  // }
  // else if (form_group.controls[all_controls[i]].errors.maxLength) {
  //   message = res + ' maximum length ' + form_group.controls[all_controls[i]].errors.maxLength.requiredLength + ' has exceeded';
  // }
  // else if (form_group.controls[all_controls[i]].errors.minLength) {
  //   message = res + ' minimum length must be ' + form_group.controls[all_controls[i]].errors.minLength.requiredLength + ' digits'
  // }
  // else if (form_group.controls[all_controls[i]].errors.min) {
  //   message = res + ' value must be greater than or equal to ' + form_group.controls[all_controls[i]].errors.min.min
  // }
  // else if (form_group.controls[all_controls[i]].errors.max) {
  //   message = res + ' value must be lesser than or equal to ' + form_group.controls[all_controls[i]].errors.max.max
  // }
  // else {
  //   message = res + ' invalid input'
  // }

  // }
}

export function findInvalidControls(form_group) {
  const invalid = {};
  const controls = form_group.controls;
  for (const name in controls) {
    if (controls[name].errors.required) {

    }
    // if (controls[name].invalid) {
    // }
  }
  return invalid;
}

export function scrollTo(el: Element) {
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }
}

